import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=2a463102&scoped=true&"
import script from "./videoPlay.vue?vue&type=script&lang=js&"
export * from "./videoPlay.vue?vue&type=script&lang=js&"
import style0 from "./videoPlay.vue?vue&type=style&index=0&id=2a463102&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a463102",
  null
  
)

component.options.__file = "videoPlay.vue"
export default component.exports